module.exports = __webpack_public_path__ + "img/astm.a96cbb78.png";